import styled from 'styled-components';
import { WithDirection } from '@jjj/components';

export const ModalBodyWrapper = styled.div`
  padding-bottom: 40px;
  padding: 0;
`;

const AvatarWrapperStyles = styled.div`
  align-items: center;
  display: flex;
  margin: ${props => (props['data-rtl'] === 'rtl' ? 'margin: 0 3px 0 0' : '0 0 0 3px')};
  position: relative;
`;

export const RadioGroupWrapper = styled.div`
  display: flex;
  justify-content: center;

  .ant-radio-wrapper {
    margin-bottom: 0;
  }
`;

export const AvatarWrapper = WithDirection(AvatarWrapperStyles);
